export default [
    { value: true, text: "Gerado", variante: "success" },
    { value: false, text: "Gerar", variante: "danger" },
]